<template>
  <div class="out-box-content">
    <div class="title ellipsis">会话分享：{{ title }}</div>
    <div v-if="messages.length" class="chat-content">
      <div v-if="!pager.complete" class="onLoadMore-class" @click="onLoadMore">加载更多</div>
      <el-x-bubble-list
          ref="bubbleListRef"
          v-loading="isLoadingMessages"
          :defaultMaxWidth="'100%'"
          :list="messages"
          :max-height="`calc(100vh - 160px)`"
          defaultShape="corner"
      >
        <template #avatar="{ item }">
          <el-avatar style="display: none"></el-avatar>
        </template>
        <template #header="{ item }">
          <div v-if="item.placement==='start'" class="share-model-name">
            <span>{{ item.model_info ? item.model_info.full_name : item.model_name }}</span>
            <span class="time">{{ item.created_at }}</span>
          </div>
        </template>
        <template #content="{ item }">
          <el-x-typewriter
              v-if="item.content && item.placement === 'start'"
              :content="item.content"
              :md-plugins="mdPlugins"
              :typing="item.typing"
              is-markdown
          />
          <div
              v-if="item.content && item.placement === 'end'"
              class="user-content"
              style="white-space: pre-wrap"
          >
            {{ item.content }}
          </div>
          <div v-for="(el, edx) in item.attachments"
               :key="edx">
            <el-x-files-card
                :img-variant="el.is_image==='1'?'square':'rectangle'"
                :name="el.name"
                :style-config="{
                backgroundColor: '#f7f7f7',
                border: '1px solid #eeeeee',
                borderRadius: '8px',
              }"
                :url="el.url"
            />
          </div>
        </template>
        <template #footer="{ item }">
          <div v-if="item.placement === 'start'&&item.status==1" class="start-action">
            <SvgIcon
                :size="20"
                color="rgb(139 139 139)"
                iconClass="action-btn"
                name="copy"
                @click.native="handleCopyMessage(item)"
            />
          </div>

        </template>
      </el-x-bubble-list>
      <div class="chat-input-footer">内容由 AI 生成，请仔细甄别</div>
    </div>
    <el-empty v-else description="分享链接已失效" style="margin-top: 200px"></el-empty>
  </div>
</template>

<script>
import markdownItMermaidPlugin from '@/utils/markdownMermaidPlugin';
import 'katex/dist/katex.min.css';
import markdownItKatex from 'markdown-it-katex';
import {share_list} from "@/api/html5";

export default {
  name: 'ChatContent',
  data() {
    return {
      mdPlugins: [markdownItMermaidPlugin, markdownItKatex],
      isLoadingMessages: false,
      messages: [],
      shareCode: '',
      pager: {
        current_page: 0,
        complete: false,
      },
      title: ''
    };
  },
  mounted() {
    const s = this.$route.query.s;
    if (s) {
      this.shareCode = s;
      this.loadMessages()
    }
  },
  methods: {
    loadMessages() {
      this.isLoadingMessages = true;
      share_list({
        code: this.shareCode,
        page: this.pager.current_page + 1
      }).then(response => {
        // 转换消息格式 - 修复消息内容处理逻辑
        const messages = [];
        response.result.rows.forEach(item => {
          // 添加用户消息
          if (item.role === 'user') {
            messages.push({
              id: `${item.id}`,
              content: item.content,
              placement: 'end',
              created_at: item.create_time,
              typing: false,
              isMarkdown: true,
              message_files: item.message_files || [],
              // 如果消息包含文件信息，添加附件
              ...(item.files &&
                  item.files.length > 0 && {
                    attachments: item.files.map(file => ({
                      id: file.id,
                      name: file.client_name,
                      url: file.url,
                      is_image: file.is_image,
                      type: file.type,
                      size: file.size,
                    })),
                  }),
            });
          }

          // 添加AI回答消息
          if (item.role === 'assistant') {
            // 处理思考内容
            let content = item.content;
            let reasoning_content = item.reasoning_content;
            let thinkingStatus = 'end';
            let model_info = item.model_info || {}

            // 检查是否包含完整的思考内容（有开始和结束标签）
            const thinkMatch = content.match(/<think>([\s\S]*?)<\/think>/);
            if (thinkMatch) {
              reasoning_content = thinkMatch[1].trim();
              content = content.replace(/<think>[\s\S]*?<\/think>/g, '');
              thinkingStatus = 'end';
            } else if (content.includes('<think>')) {
              // 只有开始标签，没有结束标签的情况
              const thinkStartIndex = content.indexOf('<think>');
              const beforeThink = content.substring(0, thinkStartIndex);
              const thinkContent = content.substring(thinkStartIndex + 7); // 7是'<think>'的长度

              content = beforeThink;
              reasoning_content = thinkContent.trim();
              thinkingStatus = 'thinking'; // 标记为思考中状态
            }

            messages.push({
              id: item.id,
              content: content,
              reasoning_content: reasoning_content,
              thinkingStatus: thinkingStatus,
              loading: thinkingStatus === 'thinking',
              placement: 'start',
              isMarkdown: true,
              avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
              avatarSize: 40,
              created_at: item.create_time,
              typing: false,
              status: 1,
              feedback: item.feedback,
              model_info: model_info
            });
          }
        });
        this.pager = response.result.pager
        //倒叙排列
        this.messages = [...messages.reverse(), ...this.messages]
        this.title = response.result.title
      }).catch(() => {
      }).finally(() => {
        this.isLoadingMessages = false;
      })
    },
    // 加载更多
    onLoadMore() {
      this.loadMessages();
    },
    // 复制消息内容
    async handleCopyMessage(item) {
      if (!item.content) return;

      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(item.content);
          this.$message.success('内容已复制到剪贴板');
        } else {
          const textArea = document.createElement('textarea');
          textArea.value = item.content;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          this.$message.success('内容已复制到剪贴板');
        }
      } catch (error) {
        console.error('复制失败:', error);
        this.$message.error('复制失败，请手动复制');
      }
    },
  },
};
</script>
<style lang="scss">
.share-model-name {
  line-height: 32px;
  display: flex;
  justify-content: space-between !important;
  align-items: center;

  .time {
    color: #a3a3a3;
  }
}
</style>
<style lang="scss" scoped>
::v-deep .el-x-bubble-content-wrapper .el-x-bubble-content-filled {
  background: #F7F7F7 !important;
  border-radius: 16px 0 16px 16px !important;
  color: #333333 !important;
  padding: 16px !important;
  line-height: 20px !important;
}

::v-deep .el-x-bubble-start .el-x-bubble-content-wrapper .el-x-bubble-content-filled {
  border-radius: 0 16px 16px 16px !important;
  background: #e8f0fc !important;
}

::v-deep .markdown-body .highlight pre, ::v-deep .markdown-body pre {
  background: #f5f2f0 !important;
}

.title {
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  background: #ffffff;
  font-weight: 500;
  font-size: 20px;
  color: #333333;
  height: 48px;
  line-height: 48px;
  padding: 0 16px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
}

.onLoadMore-class {
  color: #4D79FF;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  padding-bottom: 8px;
}

.chat-content {
  padding: 0 0 15px 0;
  //max-width: 960px;
  margin: 64px auto 0;

  ::v-deep .el-x-bubble-list {
    .el-x-bubble.el-x-bubble-start {
      .el-x-bubble-content-wrapper {
        .el-x-bubble-header,
        .el-x-bubble-content:not(.el-x-bubble-content-loading) {
          width: 100%;
        }

        .el-x-bubble-footer {
          .end-action,
          .start-action {
            display: flex;
            gap: 10px;
            align-items: center;
            opacity: 1;
            transition: opacity 0.2s ease;

            .action-btn {
              cursor: pointer;
            }
          }
        }
      }
    }

    .el-x-bubble.el-x-bubble-end {
      &:hover {
        .el-x-bubble-content-wrapper {
          .el-x-bubble-footer {
            .end-action {
              opacity: 1;
            }
          }
        }
      }
    }
  }
}

.out-box-content {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  .chat-content {
    position: relative;
    min-height: 100%;
    padding: 0 32px 15px 32px;
  }

  ::v-deep .el-x-bubble-content {
    font-size: 16px !important;
  }

  ::v-deep .el-x-bubble-list {
    height: auto;
    max-height: none;
    //max-width: 960px;
    width: 100%;
    margin: 0 auto;

    .markdown-body {
      font-size: 16px !important;
      max-width: 100%;

      h1 {
        font-size: 1.4em;
      }

      h2 {
        font-size: 1.2em;
      }

      h3 {
        font-size: 1.1em;
      }

      h4 {
        font-size: 1.05em;
      }
    }

    .el-x-bubble {
      gap: unset !important;
    }
  }
}

@media (max-width: 767px) {
  .out-box-content {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */
  }
  .out-box-content::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
    width: 0;
    height: 0;
  }
  .chat-content {
    padding: 0 16px 15px 16px !important;
  }
}

.start-action {
  display: flex;
  gap: 10px;
  align-items: center;
  max-width: 100%;
  overflow: hidden;
  flex-shrink: 0;

  .action-btn {
    cursor: pointer;
    border-radius: 4px;
    flex-shrink: 0;
  }
}

.chat-input-footer {
  font-size: 12px;
  color: #a3a3a3;
  margin: 16px 0;
  line-height: 14px;
  text-align: center;
}
</style>
